import {
  AmountFraction,
  AmountFractionType,
} from '@webapp/components/AmountFraction'
import { Quantity } from '@webapp/components/Quantity'
import { type BillItemSummary } from '@webapp/domain/accountsPayable/entities'
import { useProcurifyIntl } from '@webapp/hooks'
import { BillItemPopoverLayout } from './BillItemPopoverLayout'
import messages from './messages'

interface BillItemSummaryReceivedQuantityContentProps {
  itemSummary: BillItemSummary
}

export const BillItemSummaryReceivedQuantityContent = ({
  itemSummary,
}: BillItemSummaryReceivedQuantityContentProps) => {
  const intl = useProcurifyIntl()

  return (
    <BillItemPopoverLayout
      title={intl.formatMessage(messages.receivedTitle)}
      bodyRows={[
        {
          id: 'received-quantity',
          label: intl.formatMessage(messages.receivedLabel),
          valueComponent: (
            <AmountFraction
              type={AmountFractionType.QUANTITY}
              amount={itemSummary.receivedQuantity}
              totalAmount={itemSummary.purchasedQuantity}
            />
          ),
        },
        {
          id: 'previously-billed-quantity',
          label: intl.formatMessage(messages.previouslyBilledLabel),
          valueComponent: (
            <AmountFraction
              type={AmountFractionType.QUANTITY}
              amount={itemSummary.previouslyBilledQuantity}
              totalAmount={itemSummary.purchasedQuantity}
            />
          ),
        },
      ]}
      footerRows={[
        {
          id: 'billable-quantity',
          label: intl.formatMessage(messages.billableLabel),
          valueComponent: (
            <Quantity quantity={itemSummary.billableQuantity} mdp />
          ),
        },
        {
          id: 'billing-quantity',
          label: intl.formatMessage(messages.billingLabel),
          valueComponent: (
            <Quantity quantity={itemSummary.currentlyBilledQuantity} />
          ),
        },
      ]}
    />
  )
}
